<template>
    <div>
        <div v-if="this.listOfLinkState.includes(state)"
                @click="showModal"
                class="pointer accent_color text-dense">
            {{localizeReceivableState(state)}}
        </div>
        <div v-else class="pointer">
            {{localizeReceivableState(state)}}
        </div>
    </div>
</template>

<script>
import {formatAsLocalizedEnum} from "@/common/format";
import {enumDef} from "@/common/enumDefs";

export default {
        computed: {
			state() {return this.params.data.receivableState}
        },
		data() {
		    return {
		    	enumDef: enumDef,
                listOfLinkState: [enumDef.allReceivablesState.Sold, enumDef.allReceivablesState.Unsold, enumDef.allReceivablesState.Selling]
		    }
		},
		methods: {
			showModal() {
				let auctionId = this.params.data.auctionId;
				this.params.showModal(auctionId)
			},
			localizeReceivableState(value) {
				return formatAsLocalizedEnum(enumDef.allReceivablesState, value);
			}
		}
	};
</script>